/*
  PurelyGoods — gratis cadeau automatisch toevoegen/verwijderen (met WAARDE-weergave).

  Werkwijze:
   - free-gift.js voegt een NORMAAL geprijsd cadeauproduct toe (bv. Neusstrips €13,95),
     herkenbaar aan property _gift:'true'.
   - Een Shopify "Buy X Get Y"-korting (besteed €X → 1 gratis) zet dat product op 100%
     korting → de klant ziet "€13,95  ->  Gratis" (doorgestreepte waarde).
   - Zo ziet de klant de waarde die hij krijgt, i.p.v. een €0-product.

  Config (in je thema, bv. theme.liquid of de cart-drawer snippet):
     window.PGFreeGift = { variantId: <VARIANT_ID_VAN_HET_CADEAU>, thresholdCents: 4500 };
     -> variantId = de variant die je ook als "Y" in de Buy-X-Get-Y-korting kiest.
     -> thresholdCents = drempel NA korting (4500 = €45; €50-bundel -10% = €45).

  Later een ander cadeau? Wissel het "Y"-product in de Shopify-korting én de variantId
  hierboven — verder hoeft er niets te veranderen.

  Belangrijk (waarom dit veilig is):
   - De drempel wordt gemeten op het bestede bedrag ZONDER de cadeauregel. Zo kan een
     normaal geprijsd (nog-niet-gratis) cadeau de meting niet vervuilen.
   - Vangnet: staat het cadeau in de cart maar maakt de Shopify-korting het NIET gratis
     (bv. net onder de drempel, korting inactief), dan wordt het cadeau verwijderd —
     de klant betaalt dus nooit voor het cadeau.
*/
(function () {
  var cfg = window.PGFreeGift || {};
  var GIFT_VARIANT_ID = cfg.variantId;
  var THRESHOLD = cfg.thresholdCents || 4500;
  if (!GIFT_VARIANT_ID) return;

  // Waarde-labeltje onder het cadeau (zichtbaar in cart-drawer + checkout).
  // >>> PAS HIER DE WAARDE AAN bij een ander cadeau (of maak VALUE_TEXT leeg voor geen label).
  //     Kan ook via config: window.PGFreeGift = { ..., valueLabel:'Cadeau', valueText:'...' }
  var VALUE_LABEL = cfg.valueLabel || 'Cadeau';
  var VALUE_TEXT  = cfg.valueText  || 't.w.v. €14,95 – gratis';

  // Properties voor de cadeauregel. _gift = herkenning (verborgen);
  // het waarde-label is een zichtbare property.
  function giftProps() {
    var p = { _gift: 'true' };
    if (VALUE_TEXT) { p[VALUE_LABEL] = VALUE_TEXT; }
    return p;
  }

  var busy = false;

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Alleen de cadeau-regel: juiste variant ÉN de _gift-property.
  function findGift(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.variant_id === GIFT_VARIANT_ID && it.properties && it.properties._gift === 'true') {
        return it;
      }
    }
    return null;
  }

  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
  }

  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: giftProps() }] })
    });
  }

  function setGiftQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  function sync() {
    if (busy) return;
    busy = true;

    getCart()
      .then(function (cart) {
        var gift = findGift(cart);

        // Kwalificerend bedrag = totaal NA korting, MINUS de cadeauregel zelf.
        // (Zo telt een nog-niet-gratis cadeau niet mee in de drempel.)
        var giftLinePrice = gift ? gift.final_line_price : 0;
        var qualifying = cart.total_price - giftLinePrice;

        // 1) Boven drempel en nog geen cadeau → toevoegen (Shopify maakt 'm gratis).
        if (qualifying >= THRESHOLD && !gift) {
          return addGift().then(refreshDrawer);
        }
        // 2) Onder drempel en cadeau staat erin → verwijderen.
        if (gift && qualifying < THRESHOLD) {
          return setGiftQty(gift.key, 0).then(refreshDrawer);
        }
        // 3) VANGNET: cadeau staat erin maar is NIET gratis (Shopify-korting greep niet)
        //    → verwijderen, zodat de klant nooit voor het cadeau betaalt.
        if (gift && gift.final_line_price > 0) {
          return setGiftQty(gift.key, 0).then(refreshDrawer);
        }
        // 4) Nooit meer dan 1 cadeau.
        if (gift && gift.quantity > 1) {
          return setGiftQty(gift.key, 1).then(refreshDrawer);
        }
      })
      .catch(function (e) { console.warn('[free-gift]', e); })
      .finally(function () { busy = false; });
  }

  document.addEventListener('cart:updated', sync);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();